import { Filter } from '@anytag/shared-molecules';
import { FilterAction } from '@anytag/shared-types';
import { Template, TemplateProps } from './Template';
import { AnalyticsInstagramUGCPostsFilterFormValues } from './schemaTypes';

export type AnalyticsInstagramUGCPostsFilterProps = TemplateProps &
  FilterAction<AnalyticsInstagramUGCPostsFilterFormValues>;

export const AnalyticsInstagramUGCPostsFilter = ({
  filter,
  setFilter,
  ...restProps
}: AnalyticsInstagramUGCPostsFilterProps) => (
  <Filter.Provider values={filter} onSubmit={setFilter} className="rounded-none p-0">
    <Template {...restProps} />
  </Filter.Provider>
);

export * from './schemaTypes';
